import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { SERVICE_AREAS } from '../data/serviceAreas';
export function Services() {
  return <section id="servicios" className="w-full bg-vm-bg py-28 lg:py-36" data-id="element-179" data-mp="1dvvm40alyahp">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-180" data-mp="18ug1uag9880d">
        <div className="max-w-4xl" data-id="element-181" data-mp="13wehznb084nu">
          <SectionLabel tone="cream" data-id="element-182" data-mp="13xfpxiwq4b1c">Servicios</SectionLabel>
          <h2 className="mt-6 font-bornia text-4xl font-bold leading-[1.03] text-white sm:text-5xl lg:text-[56px]" data-id="element-183" data-mp="z4mmqzgwlard">
            Todo lo que necesitás para comunicar tu marca
          </h2>
          <p className="mt-6 max-w-2xl text-lg font-light leading-relaxed text-vm-muted" data-id="element-184" data-mp="q4q5hiwufe6c">
            Trabajamos en cuatro áreas principales. Entrá en cada una para ver los servicios específicos.
          </p>
        </div>

        <div className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-185" data-mp="g7bnvfz6ojcg">
          {SERVICE_AREAS.map((area, index) => {
          const AreaIcon = area.icon;
          return <motion.div key={area.slug} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.06
          }} data-id="element-186" data-mp="3b3ppqtim0l7k" data-mpi={index}>
                <Link to={`/servicios/${area.slug}`} className="group flex h-full flex-col justify-between gap-6 rounded-2xl border border-white/20 p-6 transition-colors duration-300 hover:border-vm-cream hover:bg-vm-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-cream focus-visible:ring-offset-2 focus-visible:ring-offset-vm-bg" data-id="element-187" data-mp="3q073fre9ubxa">
                  <AreaIcon className="h-8 w-8 text-vm-sky transition-colors duration-300 group-hover:text-vm-bg" strokeWidth={1.5} aria-hidden="true" data-id="element-188" data-mp="24muhfxwdpj8i" />
                  <span className="flex items-end justify-between gap-3" data-id="element-189" data-mp="1pjb01u24oe1h">
                    <span className="font-bornia text-xl font-semibold leading-tight text-white transition-colors duration-300 group-hover:text-vm-bg" data-id="element-190" data-mp="1ljk2n7i3iznz">
                      {area.name}
                    </span>
                    <ArrowRightIcon className="h-5 w-5 shrink-0 text-vm-muted transition-all duration-300 group-hover:translate-x-1 group-hover:text-vm-bg" aria-hidden="true" data-id="element-191" data-mp="1bs687e504q1p" />
                  </span>
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}